import PropTypes from 'prop-types';
import styles from './newCustomInput.module.css';

const NewCustomInput = ({ label, name, type, value, onChange, placeholder, required, error, language }) => {
  // Detect RTL (Urdu/Arabic) content
  const getDirection = (text) => {
    const rtlChars = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return rtlChars.test(text) ? "rtl" : "ltr";
  };

  const isUrdu = language === "Urdu";
  const dir = isUrdu ? "rtl" : getDirection(value || "");

  return (
    <div className="mb-1 w-full">
      <div className={styles.input__wrapper}>
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          title={label}
          required={required}
          dir={dir}
          className={`${styles.input__field} w-full px-3 py-2 bg-white
            ${dir === "rtl" ? "text-right" : "text-left"}
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
          `}
        />
        <label 
          htmlFor={name} 
          className={`${styles.input__label} ${dir === "rtl" ? "right-3" : "left-3"}`}
        >
          {placeholder}
        </label>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

NewCustomInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  language: PropTypes.string,   // ✅ added
};

NewCustomInput.defaultProps = {
  type: 'text',
  value: '',
  placeholder: '',
  error: null,
  required: false,
  language: 'English',
};

export default NewCustomInput;
